import React, {Fragment} from "react";
import {FaSolidIcon} from "../../../components/FontAwesomeIcons";
import Page from "../../../components/BaseComponents/Page/Page";
import AppConfig from "../../../config/AppConfig";
import {AddNotes} from "../../../img/illustrations/search-page/AddNotes";
import {CronologiaVuota} from "../../../img/illustrations/CronologiaVuota";
import {PageFooter} from "../../../components/BaseComponents/Page/PageFooter";


export default class RebookNoteModal extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            newNoteSubmit: props.newNoteSubmit,
            newNote: ''
        }
    }

    handleCopyNotes = _ => {
        this.setState({newNote: this.props.oldNote});
    }

    handleConfirmNotes = _ => {
        this.state.newNoteSubmit({
            newNote: this.state.newNote
        });
    }

    handleChangeNote = e =>{
        this.setState({newNote: e.target.value})
    }


    render() {

        return (
                <Page
                    title={"Note"}
                    active={this.props.active}
                    leftIcon={<FaSolidIcon name={"chevron-left"}/>}
                    
                    onLeftIconClick={this.props.onDismiss}
                    content = {
                        <div className={"container mt-4"}>
                            <div className={"row"}>
                                <div className={"col-12 text-center"}>
                                    <AddNotes className={"img-fluid w-50 mx-auto"} color={this.props.primaryColor}/>
                                </div>
                                <div className={"col-12 pt-4"}>
                                    <span className={"text-muted"}>Nello scorso appuntamento avevi scritto:</span>
                                    <p>{this.props.oldNote}</p>
                                    <button className={"btn btn-link p-0"} onClick={this.handleCopyNotes}>Copia la stessa nota</button>
                                </div>
                            </div>


                            <hr/>
                            <div className={"from-group mt-4"}>
                                <label>Inserisci nuove note</label>
                                <textarea className={"form-control"} name="newNote"
                                          placeholder={this.props.notes_placeholder}
                                          onChange={this.handleChangeNote}
                                          value={this.state.newNote}/>
                            </div>
                        </div>
                    }
                    footer={
                        <PageFooter className={"bg-main-z2 p-3 border-top"}>
                            <button className={"btn btn-lg btn-block btn-primary text-on-bg-primary"} onClick={this.handleConfirmNotes}>
                                Prenota
                            </button>
                        </PageFooter>
                    }
                />

        )

    }
}